import type { FaireProductEntity } from "../../entity_types/product";

export const p_k5nub276ma: FaireProductEntity = {
  token: "p_k5nub276ma",
  type: "product",
  name: "Resort: Novelty Mahjong Playing Card (Set of 4)",
  brandToken: "b_m2upumjee3",
  brandName: "Mahjong & Magnolias",
  imageUrl:
    "https://cdn.faire.com/fastly/fc44f7e12b7dda543ef3e404aee40bb9fc4507493d2d15fa26e46114bae1789c.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/f6f17d929ae042b83cb61a129175e242ad9d5a689c5539ef0fbc0b1d72c1d627.jpeg",
    "https://cdn.faire.com/fastly/86655fd0b5f7691070245ab5a9de4a8a71645d39f527b6faad871261f364601f.jpeg",
    "https://cdn.faire.com/fastly/e36ca194bba811e09c70a78028dc48f4d5edd2d94e92e76a732fe4b7e513a456.jpeg",
  ],
  priceDollars: 24,
  description:
    "A delightful alternative to the standard National Mahjong League card.  Our cards use the same tiles and the same rules as American Mahjong but a unique legend. The cards have a wordplay twist and use tiles to spell words like Puzzle, Ranch and Villa. \n\nThese matte laminated cards are sold in sets of four so everyone in your group can play.\n\nTo learn more check out the video below.",
  tags: [],
  msrpDollars: 48,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-08-15T03:49:51.040Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
